import React, { Component } from 'react'
import { Form, Row, Col, Alert, InputGroup } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable, action } from 'mobx'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { isNumeric } from '../../../../utils/objectutils'
import VariantView from '../VariantView'
import SerialkeyView from '../SerialkeyView'
import BatchkeyView from '../BatchkeyView'
import RFIDView from '../RFIDView'
import { colors } from '../../../../styles/colors'
import { getMetaProperty } from '../../../../utils/customerPrototypes'
import { isEmptyStr } from '../../../../utils/objectutils'
import copy from '../../../../assets/icons/copy.png'
import { Link } from 'react-router-dom'

const StyledWrapper = styled.div`
  padding: 10px;
  flex-grow: 1;
  border-bottom: 1px solid ${colors.gray3};
`
const LinksRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`
const StyledCopyLink = styled(Link)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #000000;
  background-color: #f0f0f0;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 0.9em;

  &:hover {
    background-color: #e2e2e2;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${copy}) center center no-repeat;
    background-size: contain;
  }
  @media (max-width: 567px) {
    flex: 0;
    width: auto;
    padding: 6px 10px;
    white-space: nowrap;
  }
`
class PositionItem extends Component {
  validationError = null
  quantityCounted = null
  serialkey = null
  batchkey = null
  rfid = null
  oldValue = null
  enforceUpdate = false
  constructor(props) {
    super(props)

    makeObservable(this, {
      validationError: observable,
      quantityCounted: observable,
      serialkey: observable,
      batchkey: observable,
      rfid: observable,
      oldValue: observable,
      enforceUpdate: observable,
      init: action,
      setPropValue: action,
    })

    this.init()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { position } = this.props
    if (
      !!this.enforceUpdate || position.enforceUpdate ||
      (!!prevProps && this.positionHasChanged(prevProps.position, position))
    ) {
      this.init()
    }
  }
  init = () => {
    const { position, handleChangePositionByKey } = this.props
    this.quantityCounted = position.quantityCounted
    this.serialkey = position.serialkey
    this.batchkey = position.batchkey
    this.rfid = position.rfid
    this.enforceUpdate = false
    handleChangePositionByKey(position.id, 'enforceUpdate', false)
  }
  positionHasChanged = (oldPosition, newPosition) => {
    const oldPositionsString = JSON.stringify(oldPosition)
    const newPositionsString = JSON.stringify(newPosition)
    return oldPositionsString !== newPositionsString
  }
  getValidationInfo = () => {
    const { position } = this.props
    const { validation } = position
    let msg = null
    let errorDetails = []

    if (validation) {
      validation.forEach((error) => {
        switch (error.source) {
          case '/serialkey':
            if (!position.serialkey) errorDetails.push(error.detail)
            break
          case '/batchkey':
            if (!position.batchkey) errorDetails.push(error.detail)
            break
          case '/rfid':
            if (!position.rfid) errorDetails.push(error.detail)
            break
          default:
            break
        }
      })
    }
    if (errorDetails.length) {
      msg = errorDetails.join('\n\n')
    }
    return msg
  }
  fieldIsDisabled = (name) => {
    const { position } = this.props
    let disabled = false
    switch (name) {
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
      case 'articleVariant':
      case 'article':
      case 'quantityCounted':
        disabled = getMetaProperty(
          position.metaProperties,
          `/${name}`,
          'isReadOnly'
        )
        break
      default:
        break
    }
    /*if(position.quantityPicked === position.quantityExpected)
      disabled = true*/
    return !!disabled
  }
  onClickSplit = async (e) => {
    e.preventDefault()
    this.splitBatchKey(true)
  }
  handleOnFocus = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnFocus", value, e, id)
    e.preventDefault()
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges('oldValue', value)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        break
      default:
        break
    }
  }
  handleOnBlur = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnBlur", value, e, id)
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges(name, value, this.oldValue, true)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        /*if (!isEmptyStr(value) && (name === 'rfid' || name === 'serialkey')) {
          this.updateQuantityChanges('quantityCounted', 1, this.oldValue, true)
        }*/
        this.updateKeyChanges(name, value)
        break
      default:
        break
    }
  }
  handleOnChange = async (e) => {
    const { value, name } = e.target
    //console.log("handleOnChange", value, e, id)
    switch (name) {
      case 'quantityCounted':
        this.updateQuantityChanges(name, value)
        break
      case 'serialkey':
      case 'batchkey':
      case 'rfid':
        this.setPropValue(name, value)
        break
      default:
        break
    }
  }
  handleOnKeyDown = async (e) => {
    if (e.key === 'Enter') {
      const { value, id, name } = e.target
      e.preventDefault() //ENTER key on keyboard and page refreshes
      const { handleNextFocus } = this.props
      switch (name) {
        case 'quantityCounted':
          this.updateQuantityChanges(name, value, this.oldValue, true)
          handleNextFocus(id, name)
          break
        case 'serialkey':
        case 'batchkey':
        case 'rfid':
          this.updateKeyChanges(name, value, true)
          handleNextFocus(id, name)
          break
        default:
          break
      }
    }
  }
  setPropValue = (name, value) => {
    this[name] = value
  }
  updateQuantityChanges = async (
    name,
    value,
    defVal = '',
    updatePosition = false
  ) => {
    const { position } = this.props
    let isValid = false
    let validValue = defVal
    if (isNumeric(value)) {
      validValue = parseInt(value)
      isValid = validValue >= 0 /*&& position.freeQuantity >= validValue*/ && position.quantityExpected >= validValue
    }
    if (!isValid) {
      validValue = defVal
    }
    switch (name) {
      case 'quantityCounted':
      default:
        this.setPropValue(name, validValue)
        break
    }
    if (!!updatePosition) {
      this.changePositionByKey(name, value)
      if (
        !!position.article.useSerialKeys &&
        !!position.serialkey &&
        position.quantityExpected > 1
      ) {
        //this.splitPosition()
        this.changePositionByKey('serialkey', '')
        this.setPropValue('enforceUpdate', true)
      } else if (
        !!position.article.useRFIDs &&
        !!position.rfid &&
        position.quantityExpected > 1
      ) {
        //this.splitPosition()
        this.changePositionByKey('rfid', '')
        this.setPropValue('enforceUpdate', true)
      }
    }
    //console.log("updateQuantityChanges", value, isNumeric(value), this[name], name, validValue)
  }
  updateKeyChanges = async (name, value, enterKeyPressed = false) => {
    const { position } = this.props
    let oldValue = position[name]
    let valueWasChanged = oldValue != value
    this.changePositionByKey(name, value)
    switch (name) {
      case 'batchkey':
      case 'rfid':
      case 'serialkey':
        if (!isEmptyStr(value)) {
          if (position.quantityExpected > 1) {
            if(name === 'batchkey')
            {
              if(enterKeyPressed)
                this.splitBatchKey()
            }
            else
            {
              this.splitPosition()
            }
          }
          else if (enterKeyPressed || valueWasChanged) {
            this.updateQuantityChanges('quantityCounted', 1, this.oldValue, true)
          }
        }
        break
      default:
        break
    }
  }
  changePositionByKey = async (name, value) => {
    const { position, index, handleChangePositionByKey, resetErrorByFormKey } =
      this.props
    resetErrorByFormKey(`positions${index}${name}`)
    handleChangePositionByKey(position.id, name, value)
  }
  splitPosition = async (splitQuantity = 1) => {
    const { position, handleSplitPosition } = this.props
    handleSplitPosition(position.id, splitQuantity)
    this.setPropValue('enforceUpdate', true)
  }
  splitBatchKey = async (setNextFocus) => {
    const { position, handleSplitPosition, handleNextFocus } = this.props
    if (position.article?.useBatchKeys && !position.article?.useSerialKeys && !!this.quantityCounted) {
      let splitQuantity = position.quantityExpected - position.quantityPicked - this.quantityCounted
      if (splitQuantity > 0) {
        await handleSplitPosition(position.id, this.quantityCounted, true)
        this.setPropValue('enforceUpdate', true)
        if (setNextFocus) {
          handleNextFocus(this.getInputId('batchkey'), 'batchkey')
        }
      }
    }
  }
  getInputId(name) {
    const { position, index } = this.props
    switch (name) {
      case 'quantityCounted':
        return `${position.id}-qc_${index}`
      case 'serialkey':
        return `${position.id}-sk_${index}`
      case 'batchkey':
        return `${position.id}-bk_${index}`
      case 'rfid':
        return `${position.id}-rfid_${index}`
      default:
        return `${position.id}-${index}`
    }
  }
  getFormError(name) {
    const { formErrors, index } = this.props
    return formErrors[`positions${index}${name}`]
  }
  renderVariantView() {
    const { position } = this.props
    const { article, articleVariant } = position
    const name = 'articleVariant'
    return (
      <VariantView
        articleId={article.id}
        selectedVariant={articleVariant}
        disabled={true/*this.fieldIsDisabled('articleVariant')*/}
        handleOnChange={this.handleOnChangeVariant}
        formError={this.getFormError(name)}
      />
    )
  }
  renderRFIDView() {
    const name = 'rfid'
    return (
      <RFIDView
        id={this.getInputId(name)}
        rfid={this.rfid}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderSerialkeyView() {
    const name = 'serialkey'
    return (
      <SerialkeyView
        id={this.getInputId(name)}
        serialkey={this.serialkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  renderBatchkeyView() {
    const name = 'batchkey'
    return (
      <BatchkeyView
        id={this.getInputId(name)}
        batchkey={this.batchkey}
        disabled={this.fieldIsDisabled(name)}
        handleOnChange={this.handleOnChange}
        handleOnBlur={this.handleOnBlur}
        handleOnKeyDown={this.handleOnKeyDown}
        formError={this.getFormError(name)}
      />
    )
  }
  getQuantityInputStyle() {
    const { position } = this.props
    if (!position.quantityCounted) {
      return { color: colors.black, backgroundColor: '#ffbbbb' }
    } else if (position.quantityCounted >= position.quantityExpected) {
      return { color: colors.black, backgroundColor: '#c9e9cd' }
    } else {
      return { color: colors.black, backgroundColor: '#ffff9d' }
    }
  }
  renderQuantityCounted() {
    const { position } = this.props
    const name = 'quantityCounted'
    const disabled = this.fieldIsDisabled(name)
    const formError = this.getFormError(name)
    return (
      <>
        <InputGroup className='m-0' style={{ width: '100px' }}>
          <Form.Control
            id={this.getInputId(name)}
            name={name}
            type='number'
            value={this.quantityCounted}
            onChange={this.handleOnChange}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            onKeyDown={this.handleOnKeyDown}
            min={position.quantityPicked ?? 0}
            max={(position.useSerialKeys || position.useRFIDs) ? 1 : position.quantityExpected}
            isInvalid={!!formError}
            disabled={!!disabled}
          />
          <InputGroup.Text
            id='basic-addon2'
            style={this.getQuantityInputStyle()}
          >
            /{position.quantityExpected}
          </InputGroup.Text>
          <Form.Control.Feedback type='invalid'>
            {formError}
          </Form.Control.Feedback>
        </InputGroup>
      </>
    )
  }
  renderActionButtons() {
    const { t, position } = this.props
    return (
      <LinksRow>
        {(position.article?.useBatchKeys && !position.article?.useSerialKeys && position.quantityExpected > 1 && !!this.quantityCounted
        && position.quantityExpected > this.quantityCounted &&  position.quantityExpected > position.quantityPicked) && (
          // <Row>
          <StyledCopyLink to={'#'} onClick={this.onClickSplit} tabIndex={-1} title={t('picking:splitPositionInfo')}>
            {t('picking:splitPosition')}
          </StyledCopyLink>
          // </Row>
        )}
      </LinksRow>
    )
  }
  renderHeader(title) {
    return <div className='fw-bold'>{title}</div>
  }
  renderTableItem() {
    const { position } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    return (
      <>
        <tr>
          <td>
            {!!position.isNewPosition && '* '}
            {article.articleNumber}
          </td>
          <td>{article.displayName}</td>
          <td>
            {!!article.isWithSizes && this.renderVariantView()}
            {!article.isWithSizes && <div>---</div>}
          </td>
          <td>
            {this.renderQuantityCounted()}
          </td>
          <td>{this.renderActionButtons()}</td>
        </tr>
        {(!!article.useSerialKeys || !!article.useBatchKeys || !!article.useRFIDs) && (
          <tr>
            <td colSpan='5'>
              <Row>
                {!!article.useRFIDs && (
                  <Col>{this.renderRFIDView()}</Col>
                )}
                {!!article.useSerialKeys && (
                  <Col>{this.renderSerialkeyView()}</Col>
                )}
                {!article.useSerialKeys && !!article.useBatchKeys && (
                  <Col>{this.renderBatchkeyView()}</Col>
                )}
              </Row>
            </td>
          </tr>
        )}
        {this.validationError && (
          <tr>
            <td colSpan='4'>
              <Alert variant='danger' className='mb-3'>
                {this.validationError}
              </Alert>
            </td>
          </tr>
        )}
        {validationInfo && (
          <tr>
            <td colSpan='4'>
              <Alert variant='info' className='mb-3'>
                {validationInfo}
              </Alert>
            </td>
          </tr>
        )}
      </>
    )
  }
  renderListItem() {
    const { t, position } = this.props
    const { article } = position
    const validationInfo = this.getValidationInfo()
    return (
      <React.Fragment>
        <StyledWrapper>
          <Row>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('productDetail:articleNumber'))}
              <div>
                {!!position.isNewPosition && '* '}
                {article.articleNumber}
              </div>
            </Col>
            <Col lg='3' sm='3'>
              {this.renderHeader(t('productDetail:articleDescription'))}
              <div>{article.displayName}</div>
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('size'))}
              {!!article.isWithSizes && this.renderVariantView()}
              {!article.isWithSizes && <div>---</div>}
            </Col>
            <Col lg='2' sm='3'>
              {this.renderHeader(t('goodsReceiptPage:quantityExpected'))}
              {this.renderQuantityCounted()}
            </Col>
            <Col lg='2' sm='3'>
              {this.renderActionButtons()}
            </Col>
          </Row>
          {(!!article.useSerialKeys || !!article.useBatchKeys || !!article.useRFIDs) && (
            <Row>
              {!!article.useRFIDs && (
                <Col>{this.renderRFIDView()}</Col>
              )}
              {!!article.useSerialKeys && (
                <Col>{this.renderSerialkeyView()}</Col>
              )}
              {!article.useSerialKeys && !!article.useBatchKeys && <Col>{this.renderBatchkeyView()}</Col>}
            </Row>
          )}
          {this.validationError && (
            <Alert variant='danger' className='mb-3'>
              {this.validationError}
            </Alert>
          )}
          {validationInfo && (
            <Alert variant='info' className='mb-3'>
              {validationInfo}
            </Alert>
          )}
        </StyledWrapper>
      </React.Fragment>
    )
  }

  render() {
    const { enforceListView } = this.props
    return (
      <>
        {!!enforceListView ? (
          this.renderListItem()
        ) : (
          <>
            {<MediaQuery maxWidth={998}>{this.renderListItem()}</MediaQuery>}
            {<MediaQuery minWidth={999}>{this.renderTableItem()}</MediaQuery>}
          </>
        )}
      </>
    )
  }
}

export default withTranslation()(observer(PositionItem))
